import { createAsyncAction } from 'typesafe-actions';
import * as types from './usersCompact.actionTypes';

export const fetchUsersCompact = createAsyncAction(
	types.FETCH_USERS_COMPACT_REQUEST,
	types.FETCH_USERS_COMPACT_SUCCESS,
	types.FETCH_USERS_COMPACT_FAILED,
)<{ withDepartmentAccess?: boolean; projection: string[] }, { usersCompact: any[] }, { error: string }>();
